module.exports = __webpack_public_path__ + "img/thumbnail-sunset.b96a21bd.jpg";